import type {
  WritingAssistGateEnvelope,
  WritingAssistGateViolation,
} from './WritingAssistFlow.types';

const REASONS = ['coach', 'redaction_preview', 'blocked'] as const;
const CATEGORIES = [
  'contact_phone',
  'contact_email',
  'contact_url',
  'contact_social',
  'offsite_steering',
  'competitor',
  'disparagement',
  'toxic',
] as const;

function isViolation(value: unknown): value is WritingAssistGateViolation {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as any;
  return CATEGORIES.indexOf(candidate.category) !== -1
    && typeof candidate.excerpt === 'string';
}

export function parseWritingAssistGateEnvelope(value: unknown): WritingAssistGateEnvelope | null {
  if (!value || typeof value !== 'object') return null;
  const candidate = value as any;
  if (candidate.saved !== false || REASONS.indexOf(candidate.reason) === -1) return null;
  if (typeof candidate.textHash !== 'string' || !candidate.textHash) return null;
  if (!Array.isArray(candidate.violations) || !candidate.violations.every(isViolation)) return null;
  if (!candidate.coach || !Array.isArray(candidate.coach.observations)) return null;
  if (candidate.reason === 'redaction_preview' && typeof candidate.redactedText !== 'string') return null;
  return candidate as WritingAssistGateEnvelope;
}

export function writingAssistGateEnvelopeFromError(error: unknown): WritingAssistGateEnvelope | null {
  if (!error || typeof error !== 'object') return null;
  const candidate = error as any;
  if (candidate.status !== 400) return null;
  return parseWritingAssistGateEnvelope(candidate.body ?? candidate.data);
}

export function isWritingAssistGateUnavailableError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const candidate = error as any;
  return candidate.status === 503
    && candidate.body?.error?.message === 'Content safety check is temporarily unavailable.';
}
